import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import { useToggles } from "../contexts/ToggleContext";

export default function AdminToggles() {
    const { refresh: refreshContext } = useToggles();
    const [items, setItems] = useState([]);
    const [busyKey, setBusyKey] = useState(null);

    const refresh = () =>
        api.get("/admin/toggles")
            .then(({ data }) => setItems(data || []))
            .catch(() => setItems([]));

    useEffect(() => { refresh(); }, []);

    const flip = async (key, next) => {
        setBusyKey(key);
        try {
            await api.patch(`/admin/toggles/${key}`, { enabled: next });
            await refresh();
            await refreshContext();
            toast.success(`${key} ${next ? "enabled" : "disabled"}`);
        } catch (e2) {
            toast.error(formatApiErrorDetail(e2.response?.data?.detail) || "Failed to update");
        } finally {
            setBusyKey(null);
        }
    };

    return (
        <div data-testid="admin-toggles-page">
            <span className="label-eyebrow">Control</span>
            <h1 className="mt-2 font-display text-4xl text-inkDark">Feature toggles</h1>
            <p className="mt-1 text-inkMuted">Switch sections on or off across the storefront.</p>

            <div className="mt-8 bg-ivory rounded-2xl border border-inkDark/5 divide-y divide-inkDark/5">
                {items.map((t) => (
                    <div key={t.key} className="flex items-center justify-between p-5" data-testid={`toggle-row-${t.key}`}>
                        <div>
                            <div className="font-medium text-inkDark">{t.label}</div>
                            <div className="text-xs text-inkMuted font-mono">{t.key}</div>
                        </div>
                        <button
                            type="button"
                            disabled={busyKey === t.key}
                            onClick={() => flip(t.key, !t.enabled)}
                            className={`w-12 h-7 rounded-full relative transition-colors ${t.enabled ? "bg-skyblueDeep" : "bg-inkDark/15"} disabled:opacity-50`}
                            aria-pressed={t.enabled}
                            data-testid={`toggle-switch-${t.key}`}
                        >
                            <span className={`absolute top-0.5 left-0.5 w-6 h-6 rounded-full bg-white transition-transform ${t.enabled ? "translate-x-5" : ""}`} />
                        </button>
                    </div>
                ))}
                {items.length === 0 ? <div className="p-8 text-center text-inkMuted">No toggles seeded.</div> : null}
            </div>
        </div>
    );
}
